import { lazyDownloadSmimeControl } from 'owa-smime';
import { getOwaMailStrings } from 'owa-strings/owa-mail-strings';
import { isBrowserChrome, isBrowserEdge, isBrowserIE } from 'owa-user-agent';
import {
    InfoBarMessageViewState,
    InfoBarMessageSource,
    InfoBarMessageRank,
    MessagePart,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

/**
 * Utility function that creates the InfobarViewState for SMIME initialization errors
 */
const getSmimeInitializationErrorInfoBar = (): InfoBarMessageViewState => {
    let messageParts: MessagePart[] = [];
    if (isBrowserChrome()) {
        messageParts.push(getOwaMailStrings().controlNotInstalledChrome);
    } else if (isBrowserEdge() || isBrowserIE()) {
        messageParts.push(getOwaMailStrings().controlNotInstalledIEAndEdge);
        messageParts.push({
            text: getOwaMailStrings().clickHere,
            action: () => {
                lazyDownloadSmimeControl
                    .import()
                    .then(downloadSmimeControl => downloadSmimeControl());
            },
        });
    }
    return {
        key: 'loadControlNotInstalledInfobar',
        source: InfoBarMessageSource.Compose,
        rank: InfoBarMessageRank.Error,
        messageParts: messageParts,
    };
};

export default getSmimeInitializationErrorInfoBar;
